module.exports = __webpack_public_path__ + "static/media/boy-20.e9b7440b.svg";